import { enableAllElementsWaitingForJs } from "@/src/utils/elementEnabler";
import { registerExternalLinkHandler } from "@/src/utils/externalLink";
import { startScheduleCycle } from "@/src/utils/schedule";

export const initPage = () => {
  startScheduleCycle();
  enableAllElementsWaitingForJs();
  registerExternalLinkHandler();
};
